import React from "react";
import { LANGS } from "../lib/i18n";
import { useApp } from "../context/AppContext";

export default function LanguageSwitcher({ variant = "text" }) {
  const { lang, setLang } = useApp();

  if (variant === "pills") {
    return (
      <div className="inline-flex items-center rounded-full p-1 glass" role="group">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            className={`px-3 py-1.5 text-xs font-semibold rounded-full transition-all ${
              lang === l.code ? "btn-gold" : "text-[var(--ink-soft)] hover:text-[var(--gold-deep)]"
            }`}
          >
            {l.short}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 text-sm">
      {LANGS.map((l, i) => (
        <React.Fragment key={l.code}>
          <button
            onClick={() => setLang(l.code)}
            className={`transition-colors ${
              lang === l.code
                ? "font-semibold text-[var(--gold-deep)]"
                : "text-[var(--ink-faint)] hover:text-[var(--gold-deep)]"
            }`}
          >
            {l.label}
          </button>
          {i < LANGS.length - 1 && <span className="text-[var(--ink-faint)]">·</span>}
        </React.Fragment>
      ))}
    </div>
  );
}
